var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EDBF5"
    },
    d: "M53.22,243.588c5.519,0,10.843,0.83,15.861,2.36c14.569-16.855,36.105-27.521,60.132-27.521 c29.347,0,54.975,15.913,68.734,39.579c4.845-1.901,10.115-2.957,15.634-2.957c19.281,0,35.587,12.741,40.957,30.263 c1.918,6.257-2.872,12.568-9.416,12.568H9.825c-6.265,0-10.955-5.801-9.586-11.915C5.67,261.713,27.328,243.588,53.22,243.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M254.539,285.313c-5.37-17.522-21.676-30.263-40.957-30.263 c-5.519,0-10.789,1.055-15.634,2.957c-13.759-23.666-39.387-39.579-68.734-39.579c-24.027,0-45.563,10.666-60.132,27.521 c-5.018-1.531-10.342-2.36-15.861-2.36c-6.312,0-12.368,1.084-18.003,3.064c-0.013,0.959-0.037,1.916-0.037,2.879 c0,16.658,2.003,32.845,5.755,48.349h204.188C251.668,297.881,256.457,291.57,254.539,285.313z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EAEAEA"
    },
    cx: 261.92,
    cy: 249.529,
    r: 204.85
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M363.042,71.347c46.268,37.56,75.844,94.881,75.844,159.119 c0,113.138-91.716,204.854-204.854,204.854c-36.779,0-71.289-9.7-101.125-26.67c35.221,28.591,80.11,45.735,129.011,45.735 c113.138,0,204.854-91.716,204.854-204.854C466.771,173.173,424.987,106.579,363.042,71.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M162.514,329.007c-10.851-10.926-28.504-10.949-39.384-0.07 c-10.88-10.879-28.533-10.856-39.384,0.07c-2.855,2.875-4.932,6.224-6.256,9.794c11.955,24.652,28.711,46.539,49.047,64.462 c0.998-0.424,1.935-1.038,2.749-1.852l32.945-32.945C173.096,357.601,173.341,339.909,162.514,329.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M320.658,329.938c-10.88-10.88-28.533-10.856-39.384,0.07 c-10.827,10.902-10.582,28.594,0.283,39.458l32.945,32.945c3.4,3.4,8.913,3.4,12.313,0l32.945-32.945 c10.864-10.864,11.109-28.557,0.283-39.458C349.191,319.082,331.538,319.059,320.658,329.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M461.908,205.029c-8.337-2.196-17.585-0.033-24.121,6.503 c-9.805-9.805-25.716-9.784-35.495,0.063c-9.758,9.825-9.537,25.771,0.255,35.562l29.692,29.692c3.064,3.064,8.033,3.064,11.097,0 l23.385-23.385c0.025-1.309,0.05-2.618,0.05-3.932C466.771,234.247,465.083,219.358,461.908,205.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M341.943,99.203c-8.821-8.821-23.135-8.802-31.933,0.057 c-8.778,8.839-8.579,23.184,0.229,31.993l26.712,26.712c2.757,2.757,7.226,2.757,9.983,0l26.712-26.712 c8.809-8.809,9.008-23.154,0.229-31.993C365.078,90.4,350.765,90.381,341.943,99.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M208.937,102.103c-14.61-14.712-38.381-14.743-53.03-0.094 c-6.658-6.658-15.2-10.272-23.909-10.866c-15.097,12.398-28.386,26.913-39.421,43.089c1.206,7.694,4.777,15.096,10.681,21 l44.36,44.36c4.578,4.578,12.001,4.578,16.579,0l44.36-44.36C223.185,140.604,223.515,116.782,208.937,102.103z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M272.357,253.41c-3.892,0-7.497-1.245-10.44-3.358c-2.943,2.113-6.549,3.358-10.44,3.358 c-9.893,0-17.94-8.048-17.94-17.94c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5c0,1.621,1.319,2.94,2.94,2.94 s2.94-1.319,2.94-2.94c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5c0,1.621,1.319,2.94,2.94,2.94c1.622,0,2.94-1.319,2.94-2.94 c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5C290.297,245.362,282.25,253.41,272.357,253.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M335.914,236.303c-4.142,0-7.5-3.357-7.5-7.5v-5.417c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5 v5.417C343.414,232.945,340.056,236.303,335.914,236.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M187.919,236.303c-4.142,0-7.5-3.357-7.5-7.5v-5.417c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5 v5.417C195.419,232.945,192.061,236.303,187.919,236.303z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6EA4"
    },
    d: "M193.948,259.243H181.89c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h12.059 c4.142,0,7.5,3.357,7.5,7.5C201.448,255.886,198.09,259.243,193.948,259.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6EA4"
    },
    d: "M341.943,259.243h-12.058c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h12.058 c4.142,0,7.5,3.357,7.5,7.5S346.085,259.243,341.943,259.243z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EDBF5"
    },
    d: "M442.377,396.294c-7.22,0-14.185,1.085-20.75,3.088c-19.06-22.05-47.233-36.003-78.666-36.003 c-38.392,0-71.919,20.818-89.919,51.778c-6.338-2.487-13.232-3.868-20.453-3.868c-25.224,0-46.555,16.668-53.581,39.59 c-2.509,8.186,3.757,16.442,12.318,16.442h307.822c8.196,0,14.331-7.589,12.54-15.587 C504.583,420.005,476.249,396.294,442.377,396.294z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.d0ad7bde.svg";
export { ForwardRef as ReactComponent };